import React from "react"
import PropTypes from "prop-types"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"

const BusinessDetailsModal = props => {
  const { isOpen, toggle, business } = props
  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabIndex="-1"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>Business Details</ModalHeader>
        <ModalBody>
          <h6 className="mb-2">
            Business id: <span className="text-primary">#{business?._id}</span>
          </h6>
          <h6 className="mb-4">
            Name: <span className="text-primary">{business?.name}</span>
          </h6>
          <p className="mb-2" style={{ wordBreak: " break-all" }}>
            Description:{" "}
            <span className="text-primary">{business?.description}</span>
          </p>
          <p className="mb-2">
            Company:{" "}
            <span className="text-primary">{business?.companyName}</span>
          </p>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

BusinessDetailsModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  business: PropTypes.object,
}

export default BusinessDetailsModal
